import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  HostListener,
  inject,
  Input,
  OnInit,
} from '@angular/core';
import { DirectiveSuperclass } from '@sama/ng-core';
import { MouseEventService } from '../../../cross-team-shared/misc-services/events/mouse-event.service';
import { assertStore } from '../../../cross-team-shared/misc-utils';
import { shellConnectorToken } from '../../../team-apis/core/shell-connector';
import { DollyService } from '../../render/cameras/dolly.service';
import { PointCloudContentStore } from '../../state/point-cloud-content-store';
import { mainViewRegionName } from '../../state/view-region-state';

@Component({
  selector: 'h3-main-view',
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class MainViewComponent
  extends DirectiveSuperclass
  implements OnInit, AfterViewInit
{
  /**
   * It is unusual to have inputs other than connectors across team
   * boundaries. Normally component size is set directly by the core team, e.g.
   * via css. This is a convenient alternative, so that we get these values into
   * our JS.
   */
  @Input({ required: true }) size!: { width: number; height: number };

  private dollyCameraService = inject(DollyService);
  private mouseEventService = inject(MouseEventService);
  private shellConnector = inject(shellConnectorToken);
  private store = inject(PointCloudContentStore);

  @HostListener('mousedown', ['$event'])
  @HostListener('mouseup', ['$event'])
  @HostListener('mousemove', ['$event'])
  @HostListener('mouseout', ['$event'])
  @HostListener('click', ['$event'])
  @HostListener('dblclick', ['$event'])
  @HostListener('wheel', ['$event'])
  handleMouseEvent(event: MouseEvent) {
    this.mouseEventService.handle({ event, target: 'container' });
  }

  ngOnInit() {
    this.updateViewRegion();
  }

  ngAfterViewInit() {
    this.dollyCameraService.setUpSubscriptions();

    this.subscribeTo(
      this.mouseEventService.getEvent$('container', 'click'),
      () => {
        this.shellConnector.handleCanvasClick();
      },
    );
  }

  private updateViewRegion() {
    const mainViewStore =
      this.store('viewRegions')('regions')(mainViewRegionName);
    assertStore(mainViewStore, 'main view region must be defined');
    mainViewStore('outputName').set(this.store.state().output.name);
  }
}
